import { ApiCandle } from '#/api/types';

import { Bar } from './external/charting_library';

export const prepareApiBarsForChart = (bars: ApiCandle[]): Bar[] => {
  return bars.map(bar => ({
    open: Number(bar.open),
    high: Number(bar.high),
    low: Number(bar.low),
    close: Number(bar.close),
    volume: Number(bar.baseVolume),
    time: bar.start, // = time in milliseconds
  }));
};
